export default (n, t) => {
  const c = [2, 0, 1, 1, 1, 2];
  return t[(n % 100 > 4 && n % 100 < 20) ? 2 : c[(n % 10 < 5) ? n % 10 : 5]];
};
